(function ($) {
    $(function () {


        if ($('#error__modal').length) {
            Fancybox.show([{
                src: "#error__modal",
                type: "inline",
                closeButton: false,
                hideScrollbar: true
            }]);
        }


        if ($('.js-open-filter-modal').length) {
            $('.js-open-filter-modal').on('click', function (e) {
                e.preventDefault();
                Fancybox.show([{
                    src: "#filter__modal",
                    type: "inline",
                    closeButton: false,
                    hideScrollbar: false
                }]);
            })
        }



        if ($('#general__popup_modal').length) {
            var popupid = $('#general__popup_modal').data('popupid');
            var isPopupOpened = sessionStorage.getItem(`popupOpened_${popupid}`);
            if (!isPopupOpened) {
                Fancybox.show([{
                    src: "#general__popup_modal",
                    type: "inline",
                    closeButton: false,
                    hideScrollbar: true,

                }], {
                    on: {
                        close: (fancybox, eventName) => {
                            sessionStorage.setItem(`popupOpened_${popupid}`, 'true');
                        },
                    },
                }
                );

            }
        }


        $('.js-clear-search-select').on('click', function (e) {
            e.preventDefault();
            $('.js-search-select-filter').val('').trigger('propertyChange');
        });


    });
})(jQuery);